<health-statistic-card
    [healthTypePath]="healthTypePath"
    [title]="title"
    [value]="lastMonitoredData"
    [dataType]="dataType"
    [period]="period"
    [isLoading]="isLoading"
    [iconPath]="'../../../assets/img/monitoring/yoga.png'">
</health-statistic-card>
